/**
 * tooltip theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/tooltip.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { tooltipAnatomy } from '@chakra-ui/react/anatomy';
export const tooltip = defineSlotRecipe({
    slots: tooltipAnatomy.keys(),
    base: {
        content: {
            color: 'black',
            bg: 'white',
            px: 2,
            py: 1.5,
            borderWidth: '1px',
            borderColor: 'text.secondary',
            rounded: '4px',
            boxShadow: 'unset',
        },
    },
    variants: {},
    compoundVariants: [],
    defaultVariants: {},
});
